import React, { useState } from "react"
import { Popover, PopoverBody, PopoverHeader, Button, Input, Alert, Progress } from "reactstrap"
import { useMutation } from "@apollo/client"
import gql from "graphql-tag"
import withApolloClient from "../../withApolloClient"

const UPDATE_INCIDENT_DOCUMENT = gql`
  mutation updateIncidentDocument($input: UpdateIncidentDocumentMutationInput!) {
    updateIncidentDocument(input: $input) {
      ok
      errors {
        field
        messages
      }
    }
  }
`

const UpdateIncidentDocumentInfo = ({ open, target, handleClose, name, value, title, type, docId, refetch }) => {
    const [input, setInput] = useState({ [name]: value || "" })
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const [updateIncidentDocument] = useMutation(UPDATE_INCIDENT_DOCUMENT)

    const updateInput = (e) => {
        setInput({ [e.target.name]: e.target.value })
    }

    const handleSubmit = async () => {
        setLoading(true)
        try {
            if (docId) {
                const res = await updateIncidentDocument({ variables: { input: { ...input, incidentDocumentId: docId } } })
                const result = res?.data?.updateIncidentDocument
                if (result?.ok) {
                    refetch?.()
                    handleClose()
                } else {
                    setError(result?.errors?.[0]?.messages?.[0] || "Update failed.")
                }
            }
        } catch (err) {
            setError("Unexpected error: " + err.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Popover isOpen={open} target={target} toggle={handleClose} placement="auto" trigger="legacy">
            <PopoverHeader>
                {title}&nbsp;&nbsp;&nbsp;<i className="fa fa-times float-right" onClick={handleClose} style={{ cursor: "pointer" }} />
            </PopoverHeader>
            <PopoverBody>
                {error && <Alert color="danger">{error}</Alert>}
                <div className="pb-2">
                    {(type === "text" || type === "textarea") && (
                        <Input
                            autoComplete="off"
                            type={type === "textarea" ? "textarea" : "text"}
                            name={name}
                            id={name}
                            value={input[name]}
                            placeholder={title}
                            onChange={updateInput}
                        />
                    )}
                    {loading ? (
                        <Progress animated color="info" value={100} />
                    ) : (
                        <div className="w-100">
                            <Button
                                className="float-right submit-button my-2 py-1"
                                size="sm"
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </div>
                    )}
                </div>
            </PopoverBody>
        </Popover>
    )
}

export default withApolloClient(UpdateIncidentDocumentInfo)
